import React, { useEffect, useState } from 'react';
import Sound from 'react-sound';
import beep from './beep.mp3';

const emptyFunction = () => {};
const Beeper = ({ playSound = true, onFinishedPlayingHandler = emptyFunction }) => {
  const [playStatus, setPlayStatus] = useState(Sound.status.STOPPED);

  useEffect(() => {
    setPlayStatus(playSound ? Sound.status.PLAYING : Sound.status.STOPPED);
  }, [playSound]);

  return <Sound url={beep} autoLoad={true} playStatus={playStatus} onFinishedPlaying={onFinishedPlayingHandler} />;
};

export default Beeper;
